export const NODE_ENV = process.env.NODE_ENV
export const BASE_URL = process.env.VUE_APP_BASE_URL1;
export const BASE_URL_SSL = process.env.VUE_APP_BASE_URL_SSL;
export const API_URL = process.env.VUE_APP_BASE_URL1 + '/api/';
export const APP_HOST = process.env.VUE_APP_HOST;

export const UPLOAD_URL = API_URL + 'media/upload';
export const MENU_URL = API_URL + 'media';

export const GOOGLE_MAPS_KEY = process.env.VUE_APP_GOOGLE_MAP_KEY;
export const API_KEY = process.env.VUE_APP_X_API_KEY;

export const DEFAULT_LATITUDE = 29.205128;
export const DEFAULT_LONGITUDE = 47.9747356;

export const ENABLE_WS = process.env.VUE_APP_ENABLE_WS;
export const PUSHER_KEY = process.env.VUE_APP_PUSHER_KEY;

export const ALTERENATE_URL = process.env.VUE_APP_ALTERENATE_URL;
export const ENABLE_THUMBOR = process.env.VUE_APP_ENABLE_THUMBOR;

export const IMG_URL =  process.env.VUE_APP_IMG_URL;
export const QR_URL =  process.env.VUE_APP_QR_URL;
export const TABLET_URL =  process.env.VUE_APP_TABLET_URL;
export const ORDERS_URL =  process.env.VUE_APP_ORDERS_URL;


